import { Stack, Typography } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import {
  complianceByIdQueryOptions,
  getFormByComplianceQueryOptions,
  type GetPartnerByIdResponse,
} from "../../api/partners";
import { prefetch } from "../../api/prefetch";
import { DynamicForm } from "../../dynamicForm";
import { Drawer } from "../../shared/Drawer";
import { usePrivacyNavigate } from "../../shared/usePrivacyNavigate";
import { trackEvent } from "../../shared/Snowplow";
import { useCurrentOrganisation } from "../../root/CurrentOrganisationProvider";

export const PartnerDrawerCompliancesSection = ({ partner }: { partner: GetPartnerByIdResponse }) => {
  const { t } = useTranslation();
  const { navigate } = usePrivacyNavigate();
  const currentOrganisation = useCurrentOrganisation();

  return (
    <>
      <DynamicForm.InlineFormSection title={t("Compliance.Drawer.Title")}>
        <Stack sx={{ gap: 1, mt: 1 }}>
          <Drawer.GoToSubDrawerButtonBase
            onMouseEnter={() => {
              prefetch(complianceByIdQueryOptions(partner.compliance.id));
              prefetch(getFormByComplianceQueryOptions());
            }}
            onClick={() => {
              trackEvent.clickComplianceSubDrawer();
              if (!currentOrganisation.partnerSecurityAndPrivacyProfileEnabled)
                trackEvent.clickVendorAssessmentPartnerDrawerWithoutFeatureEnabled();
              navigate("compliance");
            }}
          >
            <Stack direction="row" sx={{ pr: 2, justifyContent: "space-between", alignItems: "center", width: "100%" }}>
              <Stack sx={{ alignItems: "flex-start" }}>
                <Typography sx={{ fontSize: theme => theme.typography.pxToRem(14), fontWeight: "600" }}>
                  {t("Compliance.Drawer.Label")}
                </Typography>
                <Typography
                  sx={{ fontSize: theme => theme.typography.pxToRem(12), color: theme => theme.palette.text.tertiary }}
                >
                  {t("Compliance.Drawer.Description")}
                </Typography>
              </Stack>
            </Stack>
          </Drawer.GoToSubDrawerButtonBase>
        </Stack>
      </DynamicForm.InlineFormSection>
    </>
  );
};
